module.exports = __webpack_public_path__ + "img/youshi.d9018f62.png";